import { message } from '@linktivity/link-ui';
import { Configuration } from '@linktivity/triplabo-shinkansen';
import {
  AUTHORIZATION_HEADER,
  ARS_VERSION_HEADER,
  ARS_API_VERSION,
  INTERNAL_SERVER_ERROR
} from '@link/share/constants';
import i18n from '@link/triplabo/i18n';
import { auth } from '@link/triplabo/stores';

const BASE_PATH = import.meta.env.VITE_APP_SHINKANSEN2C_API as string;

const config = new Configuration({
  basePath: BASE_PATH,
  middleware: [
    {
      pre: async (context: { init: RequestInit }) => {
        const requestHeaders: HeadersInit = new Headers({
          'Content-Type': 'application/json'
        });
        requestHeaders.set(AUTHORIZATION_HEADER, auth.getAccessToken());
        requestHeaders.set(ARS_VERSION_HEADER, ARS_API_VERSION);
        context.init.headers = requestHeaders;
      },
      post: async (context: { response: Response }) => {
        if (context.response.status === 401) {
          auth.clearUser();
          const currentPath = window.location.pathname;
          const searchParams = window.location.search;
          window.location.replace(
            `/login?redirect=${encodeURIComponent(currentPath + searchParams)}`
          );
          return;
        }

        const clonedResponse = context.response.clone();
        const data = await clonedResponse.json();
        const errorMsg =
          data?.message ||
          data?.common?.error_description ||
          data?.details?.[0]?.reason;

        if (!context.response.ok || errorMsg) {
          if (context.response.status === INTERNAL_SERVER_ERROR) {
            message.error(i18n.t('share.apiErrors.serverError'), 10);
          } else {
            message.error(errorMsg, 10);
          }
        }
      }
    }
  ]
});

export default config;
